import { environmentBuildInfo } from './build-info';

export const environment = {
  production: false,
  buildEnvironment: 'development',
  buildNumber: environmentBuildInfo.development.buildNumber,
  buildVersion: environmentBuildInfo.development.version,
  buildTimestamp: environmentBuildInfo.development.buildTimestamp,
  projectName: 'Bitbridge Billing',
  sentry: {
    dsn: '',
    environment: 'development',
    release: `Bitbridge Billing@${environmentBuildInfo.development.version}`,
    tracesSampleRate: 0.2,
    enabled: false,
  },
  cdnBaseUrl: 'https://commerce.fra1.cdn.digitaloceanspaces.com',
  apiServer: 'https://api.bitbridge.co.za',
  reactiveServer: 'https://api.bitbridge.co.za/v1/',
  mapboxToken: 'pk.eyJ1IjoiYml0YnJpZGdlLWdlbyIsImEiOiJjbHYyNDZ3azYwYzN6MmptaXZjM2d3cTdtIn0.r0zpqbrTv8pBGBYesuNq3A',
  security: {
    cdnBaseUrl: 'https://commerce.fra1.cdn.digitaloceanspaces.com',
    trustedAssetHosts: ['commerce.fra1.cdn.digitaloceanspaces.com', 'commerce.fra1.digitaloceanspaces.com', 'm.billing.bitbridge.co.za'],
    trustedMediaHosts: ['commerce.fra1.cdn.digitaloceanspaces.com', 'commerce.fra1.digitaloceanspaces.com'],
    trustedFrameHosts: ['*.billing.bitbridge.co.za', 'billing.bitbridge.co.za'],
    trustedNavigationHosts: ['*.billing.bitbridge.co.za', 'billing.bitbridge.co.za', 'www.moneyweb.co.za', 'uk.trustpilot.com', 'www.fnb.co.za', 'www.nedbank.co.za', 'www.absa.co.za', 'www.standardbank.co.za', 'www.capitecbank.co.za', 'apps.apple.com', 'play.google.com', 'wa.me'],
    trustedScriptHosts: [],
    trustedConnectHosts: [
      'api.bitbridge.co.za',
      'api-test.bitbridge.co.za',
      'api-uat.bitbridge.co.za',
      'api.mapbox.com',
      'events.mapbox.com',
      'firebaseinstallations.googleapis.com',
      'fcmregistrations.googleapis.com',
      '*.googleapis.com',
      '*.gstatic.com',
      '*.firebaseio.com',
      'commerce.fra1.cdn.digitaloceanspaces.com',
      'commerce.fra1.digitaloceanspaces.com'
    ]
  },
  firebase: {
    apiKey: "AIzaSyDGe5wf2tF0Vs6mRtsrpL9fxRsnZyiKlaE",
    authDomain: "fas-staging-382114.firebaseapp.com",
    projectId: "fas-staging-382114",
    storageBucket: "fas-staging-382114.firebasestorage.app",
    messagingSenderId: "190039114091",
    appId: "1:190039114091:web:884e54ceb0fbad6a0a8c2e",
    measurementId: "G-R5SWF28E7L",
    vapidKey: 'BE_LWcSu7zFRoVKx_atrNfplwDPjjqiR9nzPgIu2vfQAMxv88PGoy11UsLeArks1VRQeUNUPgISUd5CqqEv-q_s'
  }
};
